import React from 'react';
import { GovFlex } from '@gov-design-system-ce/react';
import { GridSkeleton, Skeleton } from '@gov-nx/component/web';
import { LayoutGap } from '@gov-nx/ui/web';

export const GunListFormSkeleton = () => (
	<LayoutGap gap="l">
		<LayoutGap gap="m">
			<LayoutGap gap="s">
				<GridSkeleton rows={4} />
			</LayoutGap>
			<GovFlex
				gap="s"
				alignItems="center"
				justifyContent="flex-end">
				<Skeleton
					width="132px"
					height="48px"
				/>
			</GovFlex>
		</LayoutGap>
	</LayoutGap>
);
